import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid place-content-center bg-gray-700 bg-opacity-50 fixed top-0 left-0 right-0 z-50 p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full" }
const _hoisted_2 = { class: "relative w-full h-full max-w-md md:h-auto" }
const _hoisted_3 = { class: "relative bg-white rounded-lg shadow dark:bg-gray-700" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close modal", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "p-6 text-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "mx-auto mb-4 text-gray-400 w-14 h-14 dark:text-gray-200",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1)
const _hoisted_9 = { class: "mb-5 text-lg font-normal text-gray-500 dark:text-gray-400" }




export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteModal',
  props: {
    item: {
        type: String,
        default: 'post'
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeDeleteModal'))),
          type: "button",
          class: "absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
        }, _hoisted_6),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("h3", _hoisted_9, "Are you sure you want to delete this " + _toDisplayString(__props.item) + "?", 1),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('deletePost'))),
            type: "button",
            class: "text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
          }, " Yes, I'm sure "),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closeDeleteModal'))),
            type: "button",
            class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
          }, "No, cancel")
        ])
      ])
    ])
  ]))
}
}

})